import { useLocation, useNavigate } from 'react-router-dom';
import { ListItem, ListItemButton, ListItemIcon } from '@mui/material';
import { ReactNode, ReactElement, CSSProperties } from 'react';
import { MenuVariant } from '@/components/Sidebar/SidebarMenu';

export const OpListItem = ({
  variant = 'primary',
  href,
  icon,
  content,
  onClick,
  style,
}: {
  variant?: MenuVariant;
  href?: string;
  icon?: ReactElement;
  content: ReactNode;
  onClick?: () => void;
  style?: CSSProperties;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = location.pathname;

  return (
    <ListItem
      style={{ padding: 0, ...style }}
      onClick={() => {
        onClick && onClick();
      }}
    >
      <ListItemButton
        selected={currentPage === href}
        sx={{
          padding: '16px',
          gap: '12px',
          backgroundColor: '#F9FCFF',
          '&.Mui-selected': {
            backgroundColor:
              variant === 'primary' || variant === 'icon' ? '#CBE3FF' : 'transparent',
          },
          borderRadius: variant === 'primary' || variant === 'icon' ? '37px' : undefined,
        }}
        onClick={() => {
          href && navigate(href);
        }}
      >
        {icon && <ListItemIcon style={{ minWidth: '24px', color: 'inherit' }}>{icon}</ListItemIcon>}
        {variant !== 'icon' && content}
      </ListItemButton>
    </ListItem>
  );
};
